<template>
	<div class="page-content">
		<!-- start page title -->
		<div class="container-fluid">
			<div class="row">
        <div class="col-12">
          <div class="page-title-box d-sm-flex align-items-center justify-content-between">
            <h4 class="mb-sm-0">Tambah Usulan</h4>
            <div class="page-title-right">
              <ol class="breadcrumb m-0">
                <li class="breadcrumb-item"><a href="/admin/usulan">Usulan</a></li>
              </ol>
            </div>
          </div>
        </div>
      </div>
			<!-- end page title -->
			
			<!-- start page content -->
			<div class="row">
				<div class="col-lg-12">
					<div class="card">
						<div class="card-body">

							<div class="d-flex justify-content-between">
								<h3 v-if="step == steps[0]" class="m-0">Data Usulan</h3>
								<h3 v-if="step == steps[1]" class="m-0">Data Proposal</h3>

								<div>
									<button type="buttton" :class="{ 'btn-info': step == steps[0], 'btn-outline-info': step !== 'data_usulan' }" @click="step = 'data_usulan'" class="btn btn-sm">Data Usulan</button> >>
									<button type="buttton" :class="{ 'btn-info': step == steps[1], 'btn-outline-info': step !== 'data_proposal' }" @click="step = 'data_proposal'" class="btn btn-sm">Data Proposal</button>
								</div>
							</div>

							<hr>
							
							<div v-if="step == steps[0]">
								<div class="row">
									<div class="col-xl-10">

										<div class="mb-3 row">
                      <label for="uraiusulan" class="col-sm-4 col-form-label fw-normal">Urai Usulan</label>
                      <div class="col-sm-8">
                        <textarea name="uraiusulan" id="uraiusulan" v-model="form.uraiusulan" rows="4" class="form-control" placeholder="Urai Usulan"></textarea>
                      </div>
                    </div>

										<div class="mb-3 row">
                      <label for="volume" class="col-sm-4 col-form-label fw-normal">Volume</label>
                      <div class="col-sm-8">
												<input type="number" name="volume" id="volume" v-model="form.volume" class="form-control" placeholder="Volume Usulan">
                      </div>
                    </div>

										<div class="mb-3 row">
                      <label for="satuan" class="col-sm-4 col-form-label fw-normal">Satuan</label>
                      <div class="col-sm-8">
												<input type="text" name="satuan" id="satuan" v-model="form.satuan" class="form-control" placeholder="Satuan Usulan">
                      </div>
                    </div>

										<div class="mb-3 row">
                      <label for="program" class="col-sm-4 col-form-label fw-normal">Program</label>
                      <div class="col-sm-8">
												<select v-model="form.id_kamususulan_program" @change="fetchKegiatan" name="program" id="program" class="form-control">
													<option value="" selected>Pilih Program</option>
													<option 
														v-for="row in program_data"
														:key="row.id"
														:value="row.id"
													>{{ row.urai }}</option>
												</select>
                      </div>
                    </div>

										<div class="mb-3 row">
                      <label for="kegiatan" class="col-sm-4 col-form-label fw-normal">Kegiatan</label>
                      <div class="col-sm-8">
												<select v-model="form.id_kamususulan_kegiatan" @change="fetchSubkegiatan" name="kegiatan" id="kegiatan" class="form-control">
													<option value="" selected>Pilih Kegiatan</option>
													<option 
														v-for="row in kegiatan_data"
														:key="row.id"
														:value="row.id"
													>{{ row.urai }}</option>
												</select>
                      </div>
                    </div>

										<div class="mb-3 row">
                      <label for="subkegiatan" class="col-sm-4 col-form-label fw-normal">Subkegiatan</label>
                      <div class="col-sm-8">
												<select v-model="form.id_kamususulan_subkegiatan" name="subkegiatan" id="subkegiatan" class="form-control">
													<option value="" selected>Pilih Subkegiatan</option>
													<option 
														v-for="row in subkegiatan_data"
														:key="row.id"
														:value="row.id"
													>{{ row.urai }}</option>
												</select>
                      </div>
                    </div>

										<div class="mb-3 row">
                      <label for="domisili" class="col-sm-4 col-form-label fw-normal">Domisili</label>
                      <div class="col-sm-8">
												<select v-model="form.id_domisili" name="domisili" id="domisili" class="form-control">
													<option value="" selected>Pilih Domisili</option>
													<option 
														v-for="row in domisilidata"
														:key="row.id"
														:value="row.id"
													>{{ row.kodedomisili + ' ' + row.uraidomisili }}</option>
												</select>
                      </div>
                    </div>

										<div class="mb-3 row">
                      <label for="alamat" class="col-sm-4 col-form-label fw-normal">Alamat</label>
                      <div class="col-sm-8">
                        <textarea name="alamat" id="alamat" v-model="form.alamat" rows="4" class="form-control" placeholder="Alamat"></textarea>
                      </div>
                    </div>

									</div>
								</div>
							</div>

						</div>
					</div>
				</div>
			</div>
			<!-- end page content -->

		</div>
	</div>
</template>

<script>
import layout from '@/layout/Index'
export default {
	layout,
	props: {
		kamususulandata: Array,
		domisilidata: Array
	},
	data() {
		return {
			steps: [
				'data_usulan',
				'data_proposal'
			],
			step: 'data_usulan',
			program_data: [],
			kegiatan_data: [],
			subkegiatan_data: [],
			form: {
				id: null,

				tahun: null,
				uraiusulan: '',
				satuan: '',
				volume: 0,
				pagu: 0,

				id_kamususulan_program: null,
				id_kamususulan_kegiatan: null,
				id_kamususulan_subkegiatan: null,

				id_domisili: null,
				alamat: ''
			}
		}
	},
	methods: {
		async fetchProgram() {
			this.program_data = this.kamususulandata.filter(
				row => row.parent_id === null
			)
		},

		async fetchKegiatan() {
			this.kegiatan_data = []
			this.kegiatan_data = this.kamususulandata.filter(
				row => row.parent_id == this.form.id_kamususulan_program
			)
		},

		async fetchSubkegiatan() {
			this.subkegiatan_data = []
			this.subkegiatan_data = this.kamususulandata.filter(
				row => row.parent_id == this.form.id_kamususulan_kegiatan
			)
		}
	},
	mounted() {
		this.fetchProgram()
	}
}
</script>